import { Card, Details, Heading, Paragraph } from '@digdir/designsystemet-react';
import { Trans, useTranslation } from 'react-i18next';

import { SummaryCard } from '../../../../../expertRegistration/json/common/summary/styledComponents';

import { SamtykkeRadio } from './samtykkeRadio';
import { ContentWrapper, StyledDetailsContent } from './styledComponents';

export const Samtykke = ({ disabled }: { disabled?: boolean }) => {
  const { t } = useTranslation('', { keyPrefix: 'form.samtykke' });

  return (
    <ContentWrapper>
      <Heading level={2} data-size="md">
        {t('deling.header')}
      </Heading>
      <Paragraph className="text-preline">
        <Trans i18nKey={'form.samtykke.deling.info'} components={[<strong key={0} />, <u key={1} />]} />
      </Paragraph>
      <SummaryCard>
        <SamtykkeRadio disabled={disabled} />
      </SummaryCard>
      <Card>
        <Details>
          <Details.Summary>{t('deling.lesmer')}</Details.Summary>
          <StyledDetailsContent>
            <Heading level={5} data-size="xs">
              {t('deling.acceptance')}
            </Heading>
            <Paragraph className="text-preline" data-size="sm">
              <Trans i18nKey={'form.samtykke.deling.acceptance_info'} components={[<u key={0} />]} />
            </Paragraph>
          </StyledDetailsContent>
          <StyledDetailsContent>
            <Heading level={5} data-size="xs">
              {t('deling.reservation')}
            </Heading>
            <Paragraph className="text-preline" data-size="sm">
              <Trans i18nKey={'form.samtykke.deling.reservation_info'} components={[<u key={0} />]} />
            </Paragraph>
          </StyledDetailsContent>
        </Details>
      </Card>
    </ContentWrapper>
  );
};
